<template>
  <div>
    <div v-if="fetching">
      <v-progress-circular
        indeterminate
      />
      Loading Tags
    </div>
    <card
      v-else
      title="Tags">

      <h6>Existing Tags</h6>
      <v-chip
        v-for="catTag in sortedCategoryTagList"
        :key="catTag.tag.id"
        color="#e14eca"
        text-color="white"
        close
        @click="clickToEditTag(catTag)"
        @input="remove(catTag)"
      >
        <v-avatar class="pink darken-1">{{ catTag.count }}</v-avatar>
        {{ catTag.tag.name }}
      </v-chip>
      <el-divider/>
      <h6>Edit/Add Tag</h6>
      <div class="row">
        <div class="col-md-4">
          <label>Tag</label>
          <el-select
            v-model="selectedTagId"
            placeholder="Name + Usage Count">
            <el-option
              v-for="item in TagList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              <span>{{ item.name }} &nbsp; {{ item.count }}</span>
              &nbsp;
              <v-icon v-if="isSelected(item.id) !== -1">check</v-icon>
            </el-option>
          </el-select>
        </div>
        <div class="col-md-4">
          <label>Display Order</label>
          <base-input
            v-model="selectedTagCount"
            type="number"
            placeholder="Count"/>

        </div>
        <div class="col-md-4">
          <base-button
            type="primary"
            @click="saveTagToCategory"
          >
            Save to Category
          </base-button>
        </div>
      </div>
    </card>
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-btn
        flat
        @click="snack = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'
import BaseButton from '@/components/BaseButton'

export default {
  components: { BaseButton },

  props: {
    category_id: ''
  },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    CategoryTagList: [],
    TagList: [],
    selectedTagId: '',
    selectedIndex: -1,
    selectedTagCount: 1,
    fetching: true
  }),
  computed: {
    sortedCategoryTagList: function () {
      return [...this.CategoryTagList].sort((x, y) => x.count - y.count)
    }
  },
  watch: {
    selectedTagId: function (newVal) {
      this.checkSelected(newVal)
    },
    selectedIndex: function (newVal) {
      if (newVal !== -1) {
        this.selectedTagCount = this.CategoryTagList[newVal].count
      }
    }
  },
  // called when page is created before dom
  created () {
    this.index()
    this.allTags()
  },
  methods: {
    index () {
      this.fetching = true
      let self = this
      axios.get('/categories/' + this.category_id + '/tags')
        .then(response => {
          self.CategoryTagList = response.data
          self.fetching = false
        })
        .catch(err => {
          if (err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            this.showError(JSON.stringify(err.response.data.errors))
          }
          self.fetching = false
          console.log(JSON.stringify(err.response.data.errors))
        })
    },
    allTags () {
      axios.get('/tags/all')
        .then(response => {
          this.TagList = response.data
        })
        .catch(err => {
          if (err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            this.showError(JSON.stringify(err.response.data.errors))
          }
          console.log(JSON.stringify(err.response.data.errors))
        })
    },
    selectTag (item) {
      this.selectedTag = item
    },

    remove (item) {
      const index = this.CategoryTagList.indexOf(item)
      // console.log(item)
      // return;
      if (confirm('Are you sure you want to delete this tag?')) {
        this.$store.state.spinning = true
        axios.delete('/categories/' + this.category_id + '/tags/' + item.tag_id)
          .then((response) => {
            this.CategoryTagList.splice(index, 1)
            this.deleteInline()
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            this.$store.state.spinning = false
            if (error && error.response && error.response.status == '403') {
              this.showError('Unauthorized')
            } else {
              console.log(error)
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
          })
      }
    },
    saveTagToCategory () {
      var data = { 'count': this.selectedTagCount }
      if (this.selectedTagId === '') {
        this.showError('Select a tag first!')
        return
      }
      // update
      // console.log('selected? ' + this.isSelected(this.selectedTagId))
      if (this.selectedIndex !== -1) {
        axios.put('/categories/' + this.category_id + '/tags/' + this.selectedTagId, data)
          .then(response => {
            Object.assign(this.CategoryTagList[this.selectedIndex], response.data)
            this.saveInline()
          })
          .catch(err => {
            // console.log(JSON.stringify(err.response.data.errors))
            if (err && err.response && err.response.status == '403') {
              this.showError('Unauthorized')
            } else {
              this.showError(JSON.stringify(err.response.data.errors))
            }
          })
        return
      }
      // post
      axios.post('/categories/' + this.category_id + '/tags/' + this.selectedTagId, data)
        .then(response => {
          this.CategoryTagList.push(response.data)
          this.selectedIndex = this.CategoryTagList.length - 1
          // this.checkSelected(this.selectedTagId);
          this.saveInline()
        })
        .catch(err => {
          console.log(err)
          // console.log(JSON.stringify(err.response.data.errors))
          if (err && err.response && err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            this.showError(JSON.stringify(err.response.data.errors))
          }
        })
    },
    checkSelected: function (tagId) {
      this.selectedIndex = this.isSelected(tagId)
    },
    isSelected: function (tagId) {
      for (var i = 0; i < this.CategoryTagList.length; i++) {
        if (this.CategoryTagList[i].tag_id === tagId) {
          return i
        }
      }
      return -1
    },
    clickToEditTag: function (catTag) {
      this.selectedTagId = catTag.tag_id
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Tag saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Tag removed from category'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    }
  }
}
</script>
